import { Card, Table, TableBody, TableContainer } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import AppLoadingAndErrorWrapper from 'src/components/common/AppLoadingAndErrorWrapper';
import FormProvider from 'src/components/hook-form/form-provider';
import Scrollbar from 'src/components/scrollbar';
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton
} from 'src/components/table';
import AppTableToolbar from 'src/components/table/AppTableToolbar';
import { USERS_TABLE_HEAD } from 'src/constants/tables-heads';
import { Order_By } from 'src/graphql';
import DeleteDialog from 'src/sections/dialogs/delete/DeleteDialog';
import useUsers from './use-users';
import UsersRow from './users-row';

export type FAQsFormType = {
  sortBy: string | undefined;
  sortDirection: Order_By.Asc | Order_By.Desc | undefined;
};

const Users = () => {
  const {
    data,
    deleteId,
    dialog,
    t,
    handleSearch,
    handleDeleteUser,
    isDeleting,
    isLoading,
    methods,
    mutate,
    query,
    setQuery,
    table,
  } = useUsers();
  return (
    <AppLoadingAndErrorWrapper isLoading={isDeleting} errorMessage={null}>
      <Helmet>
        <title>{t('sidebar.appUsers')}</title>
      </Helmet>
      <Card>
        <FormProvider methods={methods}>
          <AppTableToolbar handleSearch={handleSearch} search={query.search!} tableName="" />
          <TableContainer>
            <Scrollbar>
              <Table>
                <TableHeadCustom
                  setQuery={setQuery}
                  headLabel={USERS_TABLE_HEAD(t)}
                  methods={methods}
                />
                <TableBody>
                  {isLoading || isDeleting ? (
                    [...Array(table.rowsPerPage)].map((i, index) => (
                      <TableSkeleton key={index} sx={{ height: 80 }} />
                    ))
                  ) : (
                    <>
                      {data?.users?.map((row) => (
                        <UsersRow key={row.id} row={row} deleteHandler={handleDeleteUser} />
                      ))}
                    </>
                  )}
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>
          {data && (
            <TablePaginationCustom
              count={+data.users_aggregate?.aggregate!?.count!}
              page={+table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
            />
          )}
        </FormProvider>
      </Card>
      <DeleteDialog
        id={deleteId!}
        idWord="id"
        isDeleting={isDeleting}
        mutate={mutate}
        onClose={dialog.onFalse}
        open={dialog.value}
      />
    </AppLoadingAndErrorWrapper>
  );
};

export default Users;
